"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = _interopRequireDefault(require("./analytics"));
var DESTINATION_PAGE_NAME = 'premier inn: seo: hotels in';
var updateDestinationPageAnalytics = _ref => {
  var {
    locationName,
    hotelDisplayedCount,
    destinations,
    hotels,
    filterType
  } = _ref;
  var hotelsAnalytics = hotels.map((hotel, i) => ({
    hotelName: hotel.name,
    hotelCode: hotel.hotelId,
    orderPosition: i + 1
  }));
  var destinationsListAnalytics = destinations === null || destinations === void 0 ? void 0 : destinations.map((destination, i) => ({
    destinationLocationName: destination.title,
    destinationPosition: i + 1
  }));
  var dlpAnalytics = {
    locationName,
    hotelDisplayedCount,
    destinations: destinationsListAnalytics,
    hotels: hotelsAnalytics,
    filterType
  };
  return _analytics.default.update({
    pageName: "".concat(DESTINATION_PAGE_NAME, " ").concat(locationName),
    dlp: dlpAnalytics
  });
};
var _default = exports.default = updateDestinationPageAnalytics;